import React from 'react';
import Routes from "./Routes";
import { ThemeProvider } from './components/ThemeContext';
import "./globle.scss";


const App = () => {
  return (
    <ThemeProvider>
      <Routes />
    </ThemeProvider>
  );
};

export default App;
